export const fitViewerSize = (size, viewport, origin = { left: 16, top: 16 }) => {
  const maxWidth = Math.max(1, viewport.width - origin.left - 16);
  const maxHeight = Math.max(1, viewport.height - origin.top - 16);
  return {
    width: Math.min(maxWidth, Math.max(Math.min(480, maxWidth), size.width)),
    height: Math.min(maxHeight, Math.max(Math.min(280, maxHeight), size.height)),
  };
};
